import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { BulkSchool } from "./BulkSchool";
import { School } from "./School";
import { ListOfClasses } from "./SchoolComponents/ListOfClasses/ListOfClasses";
import ReservationBulkSchoolPage from "./SchoolComponents/ReservationBulkSchoolPage/ReservationBulkSchoolPage";
import { ReservationSchoolPage } from "./SchoolComponents/ReservationSchoolPage/ReservationSchoolPage";
import { getAuthenticated } from "utils/functions";

export const SchoolLinkRouting = () => {
  const isAuthenticated = getAuthenticated();
  const isAuth =
    localStorage.getItem("memberPortal") === "true" ? isAuthenticated : false;
  const { classDetails } = useSelector((state) => state?.Class);
  const isReservedNotAllowed =
    !classDetails?.allow_non_members_register && !isAuth;

  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route exact path="/school/" component={ListOfClasses} />
          <Route exact path="/school/:id" component={School} />
          <Route
            exact
            path="/school/:id/registration"
            render={() =>
              isReservedNotAllowed ? (
                <Redirect to={`/school/${classDetails?._id}`} />
              ) : (
                <ReservationSchoolPage />
              )
            }
          />
          <Route exact path="/school/bulk/:id" component={BulkSchool} />
          <Route
            exact
            path="/school/bulk/:id/registration"
            component={ReservationBulkSchoolPage}
          />
        </Switch>
      </BrowserRouter>
    </>
  );
};
